import { EIconButtons } from './iconsTypes';

export interface ItemWithId {
	id: number;
}

export type TPage = {
	pageNumber: number;
	pageSize: number;
	totalCount: number;
};

export interface IRequestWithPageSortFilterSearch extends TPageRequest {
	filters?: TFilter[];
	orderBy?: TOrderBy[];
	searchString?: string;
}

export type TPageRequest = {
	pageSize?: number;
	pageNumber?: number;
};

export type TFilter = {
	fieldName: string;
	value: string | number | string[] | number[];
	operator: string;
};
export enum ESortDirection {
	ASC = 'asc',
	DESC = 'desc',
}
export type TFilters = TFilter[];
export type TOrderBy = {
	fieldName: string;
	direction: ESortDirection;
};

export interface IPageResponse<TReportsItem> {
	pageNumber?: number;
	pageSize?: number;
	totalCount?: number;
	data: TReportsItem[];
}

export type TTableStructureButton = {
	name: string;
	label?: string;
	icon?: EIconButtons;
	iconWithName?: boolean;
	color?: string;
	tooltip?: string;
};
